import { db, SyncManager } from 'db';
import { useField } from 'react-final-form';
import { useFormVehicleId } from './useFormVehicleId';

export const useRemoveVideo = (sectionId: string) => {
  const {
    input: { value: serverId }
  } = useField(`${sectionId}.id`);

  const {
    input: { onChange: setVideo }
  } = useField(`${sectionId}.video`);

  const vehicleId = useFormVehicleId();

  const removeVideo = async () => {
    if (!vehicleId) return;
    const syncManager = SyncManager.getInstance(vehicleId);
    const pendingUpload = await db.videoUploads
      .where('formId')
      .equals(vehicleId)
      .and(v => v.sectionId === serverId && v.synced === false && v.status === 'unsynced')
      .first();

    if (pendingUpload) {
      // handle case when upload is not started yet
      await db.videoUploads.delete(pendingUpload.id);
    } else {
      await syncManager.queueEntityUpdate(serverId, 'section', ['video', '']);
    }
    setVideo(null);
  };

  return removeVideo;
};
